// Hizmet sayfalarının içerik verisi.
// İçerikler AdsManager markasına özgü yazılmıştır — dijipo.com ile
// kopya içerik oluşturmamak SEO açısından kritiktir; yeni sayfa eklerken
// içeriği bu markanın diliyle (platform + ajans hibrit) özgün yazın.

import { EK_HIZMETLER } from "./hizmet_ek_data";

export interface HizmetVerisi {
  slug: string; // tam yol, örn: /facebook-reklam-hesabi-kiralama
  breadcrumbName: string;
  seoTitle: string;
  seoDescription: string;
  serviceType: string;
  badge: string;
  h1Top: string;
  h1Vurgu: string;
  heroText: string;
  panelTitle: string;
  panelText: string;
  panelTags: [string, string, string, string];
  sectionTitle: string;
  sectionIntro: string;
  cards: { t: string; d: string }[];
  darkTitle: string;
  darkText: string;
  faqs: { q: string; a: string }[];
  ctaTitle: string;
  ctaText: string;
  /** GEO: yapay zeka asistanlarının alıntıladığı doğrudan cevap bloğu (isteğe bağlı) */
  kisaCevapSoru?: string;
  kisaCevap?: string;
  /** İlgili sayfalar (iç veya dış bağlantı) */
  ilgili?: { href: string; label: string }[];
}

const TEMEL_HIZMETLER: HizmetVerisi[] = [
  {
    slug: "/facebook-reklam-hesabi-kiralama",
    breadcrumbName: "Facebook Reklam Hesabı Kiralama",
    seoTitle: "Facebook Reklam Hesabı Kiralama | Yüksek Limitli Ajans Hesabı — AdsManager",
    seoDescription:
      "Yüksek limitli Facebook & Instagram ajans reklam hesabı kiralama: aynı gün kurulum, yüksek harcama limiti, kurumsal faturalandırma, politika ön kontrolü ve 7/24 destek. Google ve TikTok ajans hesapları da mevcut.",
    serviceType: "Facebook Reklam Hesabı Kiralama (Ajans Hesabı)",
    badge: "ANA HİZMET: AJANS REKLAM HESABI",
    h1Top: "Facebook Reklam Hesabı",
    h1Vurgu: "Kiralama",
    heroText:
      "Günlük harcama limitine mi takıldınız, kurumsal faturalandırma ve ajans kanalından destek mi arıyorsunuz? AdsManager, Meta'nın resmi iş ortaklıkları üzerinden sağlanan yüksek limitli ajans reklam hesaplarını (agency ad account) markaların kullanımına açar. Aynı gün kurulum, yüksek harcama limiti, kurumsal doğrulama ve politika ön kontrolü — Google Ads ve TikTok ajans hesaplarıyla birlikte.",
    panelTitle: "Neden Ajans Hesabı?",
    panelText:
      "Kişisel reklam hesapları düşük limitle başlar; ödeme veya kreatif kaynaklı sorunlarda reklamlar durabilir. Ajans hesapları kurumsal doğrulamalıdır: yüksek limit, öncelikli Meta desteği ve itiraz süreçlerinde ajans kanalı avantajı sunar.",
    panelTags: ["AYNI GÜN KURULUM", "YÜKSEK HARCAMA LİMİTİ", "POLİTİKA ÖN KONTROLÜ", "7/24 DESTEK"],
    sectionTitle: "Nasıl Çalışır? 4 Adımda Ajans Hesabınız Hazır",
    sectionIntro:
      "Süreç şeffaftır: hesap mülkiyeti ve reklam verileriniz her zaman görünürdür, Business Manager'ınıza bağlanır, dilediğiniz an ayrılabilirsiniz.",
    cards: [
      {
        t: "1. İhtiyaç Analizi ve Uygunluk",
        d: "Sektörünüzü ve aylık harcama hedefinizi alıyoruz. Meta politikalarına uygunluk ön kontrolü yapıyoruz — yasaklı kategorilerde hizmet vermiyoruz; bu, hesapların uzun ömürlü kalmasının ön şartıdır.",
      },
      {
        t: "2. Hesap Tahsisi ve BM Bağlantısı",
        d: "Size tahsis edilen ajans hesabı, kendi Business Manager'ınıza partner olarak bağlanır. Piksel, katalog ve kitleleriniz kendi varlığınızda kalır; veri kaybı yaşamazsınız.",
      },
      {
        t: "3. Bakiye Yükleme",
        d: "Harcama bütçenizi hesaba bakiye olarak yüklersiniz; harcamalar şeffaf panelden anlık izlenir. Faturalandırma kurumsal ve düzenlidir.",
      },
      {
        t: "4. Yayın, İzleme ve Destek",
        d: "Reklamlarınızı kendiniz yönetebilir veya yönetimi ekibimize bırakabilirsiniz. Olası reklam reddi/itiraz süreçlerinde ajans kanalından öncelikli destek alırsınız.",
      },
    ],
    darkTitle: "Hesap Güvenliği Politika Uyumuyla Başlar",
    darkText:
      "Hesap kapanmaları çoğunlukla ödeme sorunları, politika ihlali sayılan kreatifler ve düşük güven skorundan kaynaklanır. Ajans hesabı bu riskleri tek başına ortadan kaldırmaz; politika uyumlu kreatif kontrolü ve doğru ödeme yapısıyla birlikte kesinti riskini azaltmaya yardımcı olur. Durumunuzu 15 dakikalık ücretsiz görüşmede analiz edelim.",
    faqs: [
      {
        q: "Facebook reklam hesabı kiralama yasal mı, güvenli mi?",
        a: "Hukuki değerlendirme için kendi hukuk danışmanınıza başvurmanızı öneririz; bu soruya hukuki bir hüküm vermiyoruz. Olgusal çerçeve şöyledir: ajans reklam hesabı, Meta'nın iş ortağı yapısındaki bir ajansın kurumsal doğrulamalı hesabıdır ve Meta'nın kullanım şartları ile reklam politikaları bu hesaplarda da aynen geçerlidir. Meta'nın Reklam Standartları'na göre her reklamveren ayrı bir reklam hesabıyla yönetilmeli, kurulu bir hesabın reklamvereni değiştirilmemeli ve yönetici erişimi gibi yetkiler satılmamalı veya kiralanmamalıdır. Hesabın sağlıklı kalması politikalara uygun kullanıma bağlıdır; bu yüzden yayına alınan kreatifleri politika ön kontrolünden geçiriyor ve yasaklı kategorilere hizmet vermiyoruz.",
      },
      {
        q: "Ücretlendirme nasıl işliyor?",
        a: "Model şeffaftır: yüklediğiniz reklam bakiyesi üzerinden önceden anlaşılan hizmet komisyonu uygulanır; gizli kesinti yoktur. Aylık harcama hacminiz büyüdükçe komisyon oranı düşer. Net teklif için harcama hedefinizle birlikte ulaşmanız yeterli.",
      },
      {
        q: "Hesap ne kadar sürede hazır olur?",
        a: "Uygunluk kontrolü sonrası ajans hesabı genellikle aynı gün içinde tahsis edilir ve Business Manager'ınıza bağlanır. Bakiye yüklemesiyle birlikte aynı gün reklam yayınına başlayabilirsiniz.",
      },
      {
        q: "Piksel ve kitle verilerim ne olur, ayrılırsam kaybeder miyim?",
        a: "Hayır. Piksel, katalog ve özel hedef kitleleriniz sizin Business Manager'ınızda tutulur; ajans hesabı yalnızca harcama tarafını üstlenir. İş birliği sona erdiğinde tüm verileriniz sizde kalır.",
      },
      {
        q: "Google Ads ve TikTok için de ajans hesabı veriyor musunuz?",
        a: "Evet. Meta'nın yanı sıra Google Ads ve TikTok Ads için de yüksek limitli ajans hesapları sağlıyoruz; üç platformu AdsManager panelinden tek yerden izleyebilirsiniz.",
      },
    ],
    ctaTitle: "Bugün Başvurun, Hesabınızı Aynı Gün Hazırlayalım",
    ctaText: "Harcama hedefinizi iletin; uygunluk kontrolünü yapıp aynı gün ajans hesabınızı hazırlayalım.",
  },
  {
    slug: "/hizmetler/reklam-yonetimi",
    breadcrumbName: "Reklam Yönetimi Hizmeti",
    seoTitle: "Reklam Yönetimi Hizmeti | Meta, Google & TikTok — AdsManager",
    seoDescription:
      "Meta, Google ve TikTok reklamlarınızı uzman ekip yönetsin: kampanya kurulumu, kreatif yönlendirme, ROAS odaklı optimizasyon, AdsManager panelinden şeffaf raporlama.",
    serviceType: "Reklam Yönetimi Hizmeti",
    badge: "HİZMET: UÇTAN UCA REKLAM YÖNETİMİ",
    h1Top: "Profesyonel",
    h1Vurgu: "Reklam Yönetimi",
    heroText:
      "AdsManager yalnızca hesap ve panel sağlamaz — isteyen markaların reklamlarını uçtan uca yönetir. Meta, Google ve TikTok kampanyalarınızı kuran, test eden ve ölçekleyen; sonuçları AdsManager panelinden şeffaf biçimde önünüze koyan bir performans ekibiyle çalışırsınız.",
    panelTitle: "Panel + Ekip = Tam Şeffaflık",
    panelText:
      "Klasik ajanslardan farkımız: yaptığımız her işlem AdsManager panelinizde anlık görünür. Hangi kampanyaya ne harcandı, ROAS ne — rapor beklemeden kendiniz izlersiniz.",
    panelTags: ["META + GOOGLE + TIKTOK", "ROAS ODAKLI KURGU", "ANLIK PANEL TAKİBİ", "HAFTALIK ÖZET RAPOR"],
    sectionTitle: "Reklam Yönetiminde Neler Yapıyoruz?",
    sectionIntro: "Bütçenizin her lirasının hesabını verebilen, dört katmanlı bir yönetim disiplini uyguluyoruz:",
    cards: [
      {
        t: "Ölçümleme ve Takip Kurulumu",
        d: "Meta Pixel + Conversions API, Google gelişmiş dönüşüm izleme ve TikTok Events API kurulumlarını eksiksiz yapıyoruz. Veri doğru akmadan optimizasyon mümkün değildir.",
      },
      {
        t: "Kampanya Mimarisi",
        d: "Soğuk kitle testleri, yeniden pazarlama ve sadık müşteri katmanlarından oluşan tam huni yapı; platformlar arası bütçe dağılımı hedef ROAS'a göre haftalık optimize edilir.",
      },
      {
        t: "Kreatif Test Döngüsü",
        d: "Her hafta yeni reklam varyantları test edilir; kazananlar ölçeklenir, yorulanlar emekliye ayrılır. Kreatif yönlendirme ve metin yazımı hizmete dahildir.",
      },
      {
        t: "Şeffaf Raporlama",
        d: "AdsManager panelinde anlık veriler + her hafta insan eliyle yazılmış özet: ne çalıştı, ne değişti, gelecek hafta planı ne.",
      },
    ],
    darkTitle: "Ajans Hesabı + Yönetim = Tek Elden Ölçekleme",
    darkText:
      "Yüksek limitli ajans hesabını reklam yönetimiyle birleştirmek, ölçeklemeyi tek elden planlamayı kolaylaştırır: yüksek limit, politika ön kontrolü ve uzman optimizasyon. Platformun hesap ve politika kuralları ajans hesaplarında da geçerlidir. İki hizmeti birlikte alan markalara avantajlı komisyon uyguluyoruz.",
    faqs: [
      {
        q: "Reklam yönetimi hizmetinin kapsamı tam olarak ne?",
        a: "Strateji, ölçümleme kurulumu, kampanya kurulumları, günlük optimizasyon, kreatif test yönetimi, bütçe dağılımı ve raporlama. Kreatif üretiminde metin ve yönlendirme bizden; görsel/video prodüksiyonu için hazır içeriklerinizi kullanır veya üretim ortaklarımıza yönlendiririz.",
      },
      {
        q: "Minimum bütçe şartınız var mı?",
        a: "Sağlıklı optimizasyon için aylık toplam 30.000 TL ve üzeri reklam bütçesi öneriyoruz; altındaki bütçelerde algoritmalar öğrenme fazından çıkamadığı için sonuç dalgalı olur. Bütçe planınızı ücretsiz görüşmede birlikte netleştiriyoruz.",
      },
      {
        q: "Sözleşme süresi ve çıkış koşulları nedir?",
        a: "Aylık sözleşmeyle çalışırız; uzun taahhüt şartımız yoktur. Reklam hesapları ve tüm veriler sizin mülkiyetinizde olduğu için ayrılık durumunda hiçbir şey kaybetmezsiniz.",
      },
      {
        q: "Sonuçları nasıl ölçüyorsunuz?",
        a: "Ana metrik ROAS'tır; yanında CAC, AOV ve dönüşüm oranını izleriz. Tüm metrikler AdsManager panelinizde anlık görünür — bizim raporumuzu beklemeden aynı veriyi kendiniz de görürsünüz.",
      },
    ],
    ctaTitle: "Reklamlarınızı Uzman Ele Bırakın",
    ctaText: "Mevcut hesabınızı ücretsiz denetleyelim; ilk görüşmede somut iyileştirme listesiyle çıkın.",
  },
  {
    slug: "/hizmetler/e-ticaret-reklam-yonetimi",
    breadcrumbName: "E-Ticaret Reklam Yönetimi",
    seoTitle: "E-Ticaret Reklam Yönetimi | Katalog, CAPI, ROAS — AdsManager",
    seoDescription:
      "E-ticaret markaları için reklam yönetimi: katalog reklamları, piksel/CAPI kurulumu, dinamik yeniden pazarlama ve ROAS hedefli ölçekleme. Yüksek limitli ajans hesabıyla birlikte.",
    serviceType: "E-Ticaret Reklam Yönetimi",
    badge: "HİZMET: E-TİCARET PERFORMANS PAZARLAMASI",
    h1Top: "E-Ticaret",
    h1Vurgu: "Reklam Yönetimi",
    heroText:
      "E-ticarette reklamın matematiği farklıdır: ürün feed'i, katalog reklamları, sepet terk kurguları ve iade payı hesaba katılmadan ROAS tablosu yanıltır. AdsManager, e-ticaret markalarının Meta, Google ve TikTok reklamlarını bu matematiğe hakim bir ekiple yönetir — gerektiğinde yüksek limitli ajans hesabıyla birlikte.",
    panelTitle: "E-Ticaretin Reklam Matematiği",
    panelText:
      "Katalog senkronu, satın alma olaylarının CAPI ile eksiksiz iletimi ve marj bazlı kampanya ayrımı: bu üçü doğru kurulmadan bütçe büyütmek, hatayı büyütmektir.",
    panelTags: ["KATALOG REKLAMLARI", "PIXEL + CAPI", "DİNAMİK REMARKETING", "MARJ BAZLI KURGU"],
    sectionTitle: "E-Ticaret Hesaplarında Uyguladığımız Sistem",
    sectionIntro: "Shopify, ikas, WooCommerce ve Ticimax altyapılarıyla entegre çalışan dört katmanlı sistem:",
    cards: [
      {
        t: "Feed ve Katalog Sağlığı",
        d: "Ürün feed'inizi Meta Katalog ve Google Merchant Center'a hatasız bağlıyoruz; başlık/görsel/GTIN optimizasyonu ve stok senkronuyla reddedilen ürün sorununu sıfırlıyoruz.",
      },
      {
        t: "Dönüşüm Verisi: CAPI",
        d: "Sunucu taraflı Conversions API ile satın almaların tamamı platforma raporlanır; iOS kayıpları kapanır, algoritma doğru kitleyi bulur.",
      },
      {
        t: "Tam Huni Kampanyalar",
        d: "Soğuk kitleye ürün keşfi, ilgilenene katalog reklamı, sepeti terk edene dinamik hatırlatma; e-ticaretin en yüksek ROAS üreten kurgusu.",
      },
      {
        t: "Marj Bazlı Ölçekleme",
        d: "Kampanyaları ürün marjına göre ayırıyoruz: kârlı ürünlere agresif, düşük marjlılara temkinli teklif. Ciro değil kâr büyütülür.",
      },
    ],
    darkTitle: "Limit Engeli Olmadan Ölçeklenin",
    darkText:
      "E-ticarette sezon zirvelerinde (11.11, Black Friday, bayram) hesap limitleri büyümenin önündeki en sinsi engeldir. Yüksek limitli ajans hesabıyla yönetimi birleştiren markalar, zirve günlerinde bütçeyi engelsiz açabilir. Sezon planınızı birlikte yapalım.",
    faqs: [
      {
        q: "Hangi e-ticaret altyapılarıyla çalışıyorsunuz?",
        a: "Shopify, ikas, WooCommerce, Ticimax ve İdeaSoft başta olmak üzere feed üretebilen tüm altyapılarla. Kurulum aşamasında piksel/CAPI ve feed bağlantılarını altyapınıza göre biz yapıyoruz.",
      },
      {
        q: "E-ticarette gerçekçi ROAS hedefi nedir?",
        a: "Hedef sektör ortalamasından değil marjınızdan hesaplanır: başabaş ROAS = 1 ÷ kâr marjı. %30 marjda 3.3x başabaştır; hedefi bunun en az 1.5 katına koyarız. Raporlarımızda iade payı düşülmüş net ROAS'ı esas alırız.",
      },
      {
        q: "Black Friday / 11.11 gibi zirve dönemlere nasıl hazırlanıyorsunuz?",
        a: "Zirveden 3-4 hafta önce kreatifler test edilmiş, kampanyalar öğrenmesini tamamlamış, bütçe otomasyonları kurulu olur; gerekiyorsa yüksek limitli ajans hesabı önceden tahsis edilir. Zirve haftası yalnızca ölçekleme yapılır, deneme yapılmaz.",
      },
      {
        q: "Sadece reklam mı, sitede dönüşüm tarafına da bakıyor musunuz?",
        a: "Reklam trafiğinin satışa dönüşmesini etkileyen ürün sayfası ve sepet akışı sorunlarını raporluyor, önceliklendirilmiş öneri listesi sunuyoruz; uygulama tarafında ekibinizle veya iş ortaklarımızla ilerlenebilir.",
      },
    ],
    ctaTitle: "E-Ticaret Reklamlarınızı Kâra Çevirin",
    ctaText: "Feed, ölçümleme ve kampanya yapınızı ücretsiz denetleyelim; net ROAS raporunuzu çıkaralım.",
  },
  {
    slug: "/hizmetler/seo-geo-hizmeti",
    breadcrumbName: "SEO & GEO Hizmeti",
    seoTitle: "SEO & GEO Hizmeti | Google ve Yapay Zeka Görünürlüğü — AdsManager",
    seoDescription:
      "Google'da üst sıralar + ChatGPT, Gemini, Perplexity gibi yapay zeka asistanlarında görünürlük (GEO). Teknik SEO, içerik stratejisi, şema kurulumu ve yapay zeka indekslerine kayıt.",
    serviceType: "SEO ve GEO (Yapay Zeka Görünürlüğü) Hizmeti",
    badge: "HİZMET: SEO + YAPAY ZEKA GÖRÜNÜRLÜĞÜ (GEO)",
    h1Top: "SEO &",
    h1Vurgu: "GEO Hizmeti",
    heroText:
      "Müşterileriniz artık yalnızca Google'a değil ChatGPT'ye, Gemini'ye ve Perplexity'ye soruyor. AdsManager'ın SEO & GEO hizmeti iki cephede birden çalışır: klasik arama motorlarında üst sıralara çıkmak ve yapay zeka asistanlarının cevaplarında markanızın önerilmesini sağlamak.",
    panelTitle: "GEO: Yeni Nesil SEO",
    panelText:
      "Yapay zeka tarayıcıları JavaScript çalıştırmaz, cevap-öncelikli içerik arar ve yapılandırılmış veriyle beslenir. Sitenizi bu yeni okuyucular için de optimize ediyoruz.",
    panelTags: ["TEKNİK SEO DENETİMİ", "AI BOT ERİŞİMİ + LLMS.TXT", "ŞEMA (JSON-LD) KURULUMU", "İÇERİK STRATEJİSİ"],
    sectionTitle: "SEO & GEO Hizmetinin Kapsamı",
    sectionIntro: "Kendi markalarımızda uyguladığımız ve sonuç aldığımız sistemin aynısını müşterilerimize kuruyoruz:",
    cards: [
      {
        t: "Teknik SEO ve Hız",
        d: "Tarama erişimi, indekslenme sorunları, Core Web Vitals ve site içi bağlantı mimarisi denetlenir; geliştirmeler öncelik sırasıyla uygulanır.",
      },
      {
        t: "GEO Altyapısı",
        d: "Yapay zeka botlarına (GPTBot, ClaudeBot, PerplexityBot...) erişim, llms.txt, statik okunabilir içerik ve IndexNow kurulumu — markanızın AI indekslerine girmesi sağlanır.",
      },
      {
        t: "Şema ve Varlık Optimizasyonu",
        d: "Organization, LocalBusiness, Service ve FAQPage şemaları; Google İşletme Profili, sosyal profiller ve marka tanımının tutarlı bağlanması (entity SEO).",
      },
      {
        t: "Cevap-Öncelikli İçerik",
        d: "Hedef kelimelere doğrudan cevap veren hizmet sayfaları ve SSS blokları; yapay zekaların alıntılamayı sevdiği formatta içerik üretimi.",
      },
    ],
    darkTitle: "Kanıt: Kendi Markalarımız",
    darkText:
      "Bu sistemi önce kendi markalarımızda kuruyoruz — AI botlarına açık altyapı, şema ağı, IndexNow ve cevap-öncelikli sayfalarla. Aynı kurulum ve içerik disiplinini sizin markanız için de işletiyoruz; ilk denetim raporu ücretsiz.",
    faqs: [
      {
        q: "GEO (Generative Engine Optimization) tam olarak nedir?",
        a: "Yapay zeka asistanlarının (ChatGPT, Gemini, Claude, Perplexity) cevaplarında markanızın görünmesini ve önerilmesini sağlama çalışmasıdır. Teknik tarafta AI botlarına erişim, llms.txt ve şema kurulumu; içerik tarafında cevap-öncelikli, alıntılanabilir sayfalar üretmeyi kapsar.",
      },
      {
        q: "SEO sonuçları ne kadar sürede görünür?",
        a: "Teknik düzeltmelerin etkisi 2-8 haftada, içerik ve otorite çalışmalarının etkisi 3-6 ayda belirginleşir. Yapay zeka görünürlüğü de benzer takvimde ilerler; her ay ölçülebilir ara raporlar sunarız.",
      },
      {
        q: "Sıralama garantisi veriyor musunuz?",
        a: "Hayır — Google ve yapay zeka sıralamalarını hiçbir ajans garanti edemez; garanti vaadi sektörde güvenilmezlik işaretidir. Bunun yerine şeffaf yol haritası, aylık ölçüm ve hedef aralıkları üzerinden hesap verebilirlik sunarız.",
      },
      {
        q: "Reklam yönetimiyle birlikte alınabilir mi?",
        a: "Evet, en verimli kombinasyon budur: reklam kısa vadeli satışı, SEO/GEO orta vadeli kalıcı trafiği getirir. İki hizmeti birlikte alan markalara paket fiyatı uygulanır.",
      },
    ],
    ctaTitle: "Google'da ve Yapay Zekalarda Görünün",
    ctaText: "Sitenizin ücretsiz SEO & GEO denetimini yapalım; eksik listesi ve yol haritasıyla dönelim.",
  },
];

/** Temel hizmetler + ek kümeler (AI reklam, ajans hesabı türleri, altyapı sayfaları) */
export const HIZMETLER: HizmetVerisi[] = [...TEMEL_HIZMETLER, ...EK_HIZMETLER];
